module.exports = __webpack_public_path__ + "img/discover.951fc4e1.png";